export const Api='/api';
export const xzApi='/api/xzxzs';
export const Xzs='/xzs';
export const BeiJin = "/bj";

export const GxCore = "core"
export const Gx = "/gx";

export const ClientId = "041fd3cdf170f4104baf5a15621344cc";